<span *ngIf="!loading && btnWrapper">
  <span *ngIf="icone">
    <i class="{{icone}}"></i>
  </span> {{texto}}
</span>

<span *ngIf="loading">
  <i class="fa fa-circle-notch fa-spin"></i>
  {{textoLoading}}
</span>